module.exports = __webpack_public_path__ + "static/media/cycle.e923fedb.ogg";